import { render, staticRenderFns } from "./SvgPlusMin.vue?vue&type=template&id=6b315176&scoped=true&"
import script from "./SvgPlusMin.vue?vue&type=script&lang=ts&"
export * from "./SvgPlusMin.vue?vue&type=script&lang=ts&"
import style0 from "./SvgPlusMin.vue?vue&type=style&index=0&id=6b315176&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b315176",
  null
  
)

export default component.exports